import * as _ from "lodash";
import {BaseWeatherModalView, BaseWeatherModalViewOptions} from "../_BaseWeatherAppViews";
import {InstallCollection} from "../../../../collections/Installs";
import * as Backbone from "backbone";
import {GenericDeleteModal} from "../../../../views/modals/GenericDeleteModal";
import {WeatherPermissionCollection} from "../../collections/WeatherAppPermissions";
import {TimezoneCollection} from "../../../../collections/Timezones";


export class ModifyLocationModal extends BaseWeatherModalView {
    options: BaseWeatherModalViewOptions;
    private template = _.template(require('../../templates/modals/modifyLocations.html'));

    constructor(options: BaseWeatherModalViewOptions) {
        super(<any> _.extend(options, {
            tagName: 'div',
            events: {
                'shown.bs.modal #addLocationModalLabel': 'handleModalShown',
                'hidden.bs.modal #addLocationModalLabel': 'handleModalHidden',
                'change .add-location-modal-app-select': 'handleOrgChange',
                'change .add-location-modal-install-select': 'handleInstallChange',
                'change .permission-checkbox': 'handlePermissionChange',
                'change .latlong-checkbox': 'handleLatLongAdd',
                'change .add-polling-freq-select': 'handleInput',

                'change .add-location-unit': 'handleUnitInput',
                'click .add-location-btn': 'sendRequest',
                'click .modify-location-btn': 'sendRequest',
                'click .delete-location-btn': 'handleDeleteButtonClick',

                'input .add-location-name': 'handleInput',
                'input .add-location-zip': 'handleInput',
                'input .add-location-latitude': 'handleInput',
                'input .add-location-longitude': 'handleInput',
                'input .add-cooling-degree-day': 'canMakeDD',
                'input .add-heating-degree-day': 'canMakeDD',
            }
        }));

        // For the base class methods
        this.modalIdSelector = 'addLocationModalLabel';

        this.options.installCollection = new InstallCollection(
            this.options.installCollection.filter((install) => {
                return Boolean(this.options.appCollection.findWhere({
                    organization_id: install.get('organization_id'),
                    type: 'weather',
                    enabled: 1
                }))
            }, this)
        );

        this.userGroupCollection = null;
        this.userGroupPermissionsCollections = {};

        this.handleInput = _.debounce(this.handleInput.bind(this), 100);
    }

    render() {
        var appId = null;
        var location = null;
        var install = null;
        var locationLatitude = null;
        var locationLongitude = null;
        if (this.options.locationId) {
            location = this.options.locationCollection.findWhere({id: this.options.locationId});
            var app = this.options.appCollection.findWhere({id: location.get('app_id')});
            install = this.options.installCollection.findWhere({organization_id: app.get('organization_id')});
            appId = location.get('app_id');
            locationLatitude = Number(location.get('latitude'));
            locationLongitude = Number(location.get('longitude'));
        }

        this.$el.html(this.template({
            installCollection: this.options.installCollection,
            organizationCollection: this.options.organizationCollection,
            newLocation: !this.options.locationId,
            locationId: this.options.locationId,
            permissionCollection: this.options.permissionCollection,
            appCollection: this.options.appCollection,
            location: location,
            install: install,
            appId: appId,
            locationLatitude: locationLatitude,
            locationLongitude: locationLongitude,
            locationHDD: location ? _.find(location.get('params'), {key: 'HDD'}) : null,
            locationCDD: location ? _.find(location.get('params'), {key: 'CDD'}) : null,
            locationUnit: location && _.find(location.get('params'), {key: 'Unit'}) ? _.find(location.get('params'), {key: 'Unit'})['value'] : 'us',
            timezones: new TimezoneCollection(),
            user: this.options.currentUser
        }));

        this.handleLatLongAdd();
        this.handleOrgChange();
        this.handleAddButtonDisabledState();

        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        window['App'].Bus.trigger('weatherapp:update:suspend');

        return this;
    }

    show() {
        (<any> this.$('#addLocationModalLabel')).modal('show');
        this.handleInstallChange();
    }

    handleOrgChange() {
        var app = this.options.appCollection.findWhere({
            id: Number(this.$('.add-location-modal-app-select').val())
        });
        var orgId = app.get('organization_id');

        // Load permissions & render toggle buttons
        $.when(this.loadPermissionsCollections(
            orgId,
            'canViewLocation',
            'canModifyLocation',
            'canDeleteLocation'
        ))
            .then(() => {
                this.$('.add-location-modal-install-select').empty().append(this.buildInstallOptions(orgId)).trigger('change');
                this.$('.add-location-btn').prop('disabled', true);
                this.handleAddButtonDisabledState();
            });
    }

    getNewPermissionCollection(usergroupId) {
        // Override base method in _BaseModifyModal
        return new WeatherPermissionCollection([], {userGroupId: usergroupId});
    }

    buildInstallOptions(orgId) {
        var orgInstalls = this.options.installCollection.where({organization_id: Number(orgId)});
        var location = this.options.locationCollection.findWhere({id: this.options.locationId});
        var locationInstallId = location ? location.get('install_id') : '';
        var options = [];

        if (!this.options.locationId) options.push("<option value=''>None</option>");

        _.each(orgInstalls, (orgInstall) => {
            var orgInstallId = _.escape(orgInstall.get('id'));
            var orgInstallName =  _.escape(orgInstall.getDisplayName());

            if (locationInstallId == orgInstallId) {
                options.push('<option selected value="' + orgInstallId + '">' + orgInstallName + '</option>');
                return;
            }

            options.push('<option value="' + orgInstallId + '">' + orgInstallName + '</option>');
        });
        return options.join('');
    }

    handleInstallChange() {
        var selectedInstallId = this.$('.add-location-modal-install-select').val();
        var install = this.options.installCollection.findWhere({id: Number(selectedInstallId)});
        var zip = install ? install.get('property_address_zip') : '';
        var takenDiv = '.install-taken';

        if (zip) this.$('.add-location-zip').val(zip);
        if (!this.$(takenDiv).hasClass('hidden')) this.$(takenDiv).addClass('hidden');

        this.options.locationCollection.each((location) => {
            if (location.get('id') === this.options.locationId) return;
            if (location.get('install_id') === Number(selectedInstallId)) this.$(takenDiv).removeClass('hidden');
        });

        if (install) {
            this.$('#timezone').hide();
        } else {
            this.$('#timezone').show();
        }

        this.handleAddButtonDisabledState();
    }

    handleLatLongAdd() {
        var useZip = !this.$('.latlong-checkbox').is(':checked');
        var newLocation = !this.options.locationId;

        if (useZip && newLocation) {
            this.$('.add-location-latitude').val("");
            this.$('.add-location-longitude').val("");
        }

        this.$('.add-location-zip').val("");

        this.$('#install-lat').toggleClass('hidden', newLocation ? useZip : false);
        this.$('#install-long').toggleClass('hidden', newLocation ? useZip : false);
        this.$('#install-zip').toggleClass('disabled', newLocation ? !useZip : false);

        this.handleAddButtonDisabledState();
    }

    handleUnitInput() {
        var unit = this.$('.add-location-unit').val() === 'us' ? '°F' : '°C';
        var degreePlaceholder = 'e.g. ' + (unit === 'us' ? '65 ()' : '18') + ' (optional)';
        this.$('.degree-unit').html(unit);
        this.$('.add-cooling-degree-day').attr('placeholder', degreePlaceholder);
        this.$('.add-heating-degree-day').attr('placeholder', degreePlaceholder);
    }

    canMakeDD(){
        var channel = this.options.locationChannelCollections[this.options.locationId].findWhere({
            channel_position: 11,
            module_number: '-1',
        });
        this.$('.dd-error').toggleClass('hidden', !!channel);
    }

    handleInput() {
        this.handleAddButtonDisabledState();
    }

    handleAddButtonDisabledState() {
        var canAssignPerms = false;
        var needsAName = !this.$('.add-location-name').val();
        var needsAZip = !this.$('.add-location-zip').val();
        var needsALatLong = !this.$('.add-location-latitude').val() || !this.$('.add-location-longitude').val();
        var installTaken = !this.$('.install-taken').hasClass('hidden');

        var updatingDegreeDays = !!this.options.locationId;
        if (updatingDegreeDays) {
            this.$('.add-location-btn').prop('disabled', false);
            this.$('.modify-location-btn').prop('disabled', false);
            return;
        }

        if (this.userGroupCollection) {
            if (this.userGroupCollection.isFetching()) {
                this.$('.add-location-btn').prop('disabled', true);
                this.$('.modify-location-btn').prop('disabled', true);
                return;
            }

            // Only allow a new location group to be created if the user can assign permissions
            this.userGroupCollection.each((group) => {
                if (this.options.permissionCollection.canModifyUserGroupPermissions(group.get('id'))) canAssignPerms = true;
            }, this)
        }

        if (needsAName || (needsAZip && needsALatLong) || !canAssignPerms || installTaken) {
            this.$('.add-location-btn').prop('disabled', true);
            this.$('.modify-location-btn').prop('disabled', true);
            return;
        }

        // Make sure at least one location group has all permissions
        var allPerms = _.some(this.$('.permission-modify').map(function () {
            return $(this).is(':checked')
        }));
        this.$('.add-location-btn').prop('disabled', !allPerms);
        this.$('.modify-location-btn').prop('disabled', !allPerms);
    }

    setFormSubmitted() {
        this.$('.modal-footer .buttons').addClass('hidden');
        this.$('.modal-footer .modal-form-spinner').removeClass('hidden');
    }

    setFormError() {
        this.$('.modal-footer .buttons').removeClass('hidden');
        this.$('.modal-footer .modal-form-spinner').addClass('hidden');
    }

    sendRequest() {
        this.setFormSubmitted();

        var errTypesToClasses = {
            'zip': '.zip-error',
            'lat': '.lat-error',
            'long': '.lng-error'
        };

        var type = this.options.locationId ? 'PUT' : 'POST';
        var urlAddon = this.options.locationId ? '/' + this.options.locationId : '';

        var data = this.getData();
        $.ajax({
            type: type,
            url: this.options.locationCollection.url() + urlAddon,
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: (response) => {
                this.refetchCollectionsAndShow(response.locationId || this.options.locationId)
            },
            error: (response) => {
                this.setFormError();

                if (response.status === 409) {
                    this.$('.install-taken').removeClass('hidden');
                    return;
                }

                _.each(errTypesToClasses, (div, errType) => {
                    if (!this.$(div).hasClass('hidden')) this.$(div).addClass('hidden');
                    if (_.includes(response.responseText, errType)) this.$(div).removeClass('hidden');
                });
            }
        });
    }

    getData() {
        var installId = this.$('.add-location-modal-install-select').val() ?
            Number(this.$('.add-location-modal-install-select').val()) : null;
        var timezone =  this.$('.profile-form-timezone').val();
        var install = this.options.installCollection.findWhere({id: installId});
        var data = {
            id: this.options.locationId,
            appId: Number(this.$('.add-location-modal-app-select').val()),
            installId: installId,
            installZip: this.$('.add-location-zip').val(),
            lat: this.$('.add-location-latitude').val(),
            long: this.$('.add-location-longitude').val(),
            name: this.$('.add-location-name').val(),
            polling_freq: Number(this.$('.add-polling-freq-select').val()),
            cool_const: this.$('.add-cooling-degree-day').val(),
            heat_const: this.$('.add-heating-degree-day').val(),
            unit: this.$('.add-location-unit').val(),
            permissions: this.getPermissionsDict(),
            timezone: install ? install.get('timezone') : timezone
        };
        if (this.options.locationId) {
            var channel = this.options.locationChannelCollections[this.options.locationId].findWhere({
                channel_position: 11,
                module_number: '-1',
            });

            if(!channel) return data;
            data['virtual_sensor_id'] = channel.get('sensor_id');
            data['tempetature_channel_id'] = channel.get('channel_id');

            var location = this.options.locationCollection.findWhere({id: this.options.locationId});

            var hddChannels = [];
            this.options.locationChannelCollections[this.options.locationId].each((c) => {
                if (_.includes([49, 50, 51, 52, 53], c.get('channel_position'))) hddChannels.push(c.get('channel_id'))
            });
            var cddChannels = [];

            this.options.locationChannelCollections[this.options.locationId].each((c) => {
                if (_.includes([54, 55, 56, 57, 58], c.get('channel_position'))) cddChannels.push(c.get('channel_id'))
            });

            var HDD = _.find(location.get('params'), {key: 'HDD'});
            var CDD = _.find(location.get('params'), {key: 'CDD'});

            data['update_heat_const'] = hddChannels && (HDD && HDD['value'] !== data['heat_const']) ? hddChannels : [];
            data['update_cool_const'] = cddChannels && (CDD && CDD['value'] !== data['cool_const']) ? cddChannels : [];

            data['create_hdd'] = !HDD ? !!data['heat_const'] : false;
            data['create_cdd'] = !CDD ? !!data['cool_const'] : false;
        }
        return data;
    }

    handleDeleteButtonClick() {
        var location = this.options.locationCollection.findWhere({id: this.options.locationId});

        var data = JSON.stringify({
            id: this.options.locationId,
            appId: Number(this.$('.add-location-modal-app-select').val()),
            install_id: Number(this.$('.add-location-modal-install-select').val()),
            permissions: this.getPermissionsDict()
        });
        var settings = {
            type: 'DELETE',
            url: this.options.locationCollection.url() + '/' + this.options.locationId,
            data: data,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        };
        var modal = new GenericDeleteModal({
            type: 'Location',
            name: location.get('name'),
            func: () => {
                this.setFormSubmitted();
                return $.when(location.destroy(settings)).done(() => {
                    this.hide();
                    window.location.hash = "#/dashboard";
                    Backbone.history.loadUrl();
                });
            }
        });

        $('.modals').append(modal.render().el);
        modal.show();
    }

    refetchCollectionsAndShow(locationId?) {
        var d1 = this.options.locationCollection.fetch();
        var d2 = this.options.permissionCollection.fetch();
        var d3 = this.options.installCollection.fetch();

        $.when(d1, d2, d3).done(() => {
            this.hide();
            if (!locationId || locationId !== this.options.locationId) {
                window.location.hash = "#/weather" + (locationId ? '/' + locationId : '');
            } else {
                // Somewhat of a hack to refresh the page
                // See http://stackoverflow.com/questions/8901574/how-to-refresh-a-page-in-a-backbone-application
                Backbone.history.loadUrl();
            }

            window['App'].Bus.trigger('navigation:update');
        }).fail(() => {
            this.setFormError();
        })
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/apps/weather/views/modals/ModifyLocationModal.ts